const documenttype = {
	name: 'Document Type | Document Types',
	icon: 'fa-fw fas fa-file',
	fields: {
		acronym: 'Acronym',
		name: 'Name',
		documents_count: 'Count',
		ordering: 'Order',
		notify: 'Notifications',
		notify_of_weeks: 'Documents not older than n weeks',
		documents_size: 'Storage',
		proposed_for_export: 'Proposed for Export',
		max_age_years: 'Max age (years)',
		document_cutoff_date: 'Cutoff date',
		display_name: 'Display name',
		display_label: 'Name',
	},
	hideColumns: {
		acronym: '@:entity.documenttype.fields.acronym',
		documents_size: '@:entity.documenttype.fields.documents_size',
	},
}

export default documenttype
